import { render } from "./SearchText.vue?vue&type=template&id=493ce88b"
import script from "./SearchText.vue?vue&type=script&lang=js"
export * from "./SearchText.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/Search/SearchText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "493ce88b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('493ce88b', __exports__)) {
    console.log('reload')
    api.reload('493ce88b', __exports__)
  }
  
  module.hot.accept("./SearchText.vue?vue&type=template&id=493ce88b", () => {
    console.log('re-render')
    api.rerender('493ce88b', render)
  })

}


export default __exports__